import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import state, { IMesureTypeState } from './state'
import { Module } from 'vuex/types'
import { IRootState } from '@/store'

const mesureTypeModule: Module<IMesureTypeState, IRootState> = {
  actions,
  getters,
  mutations,
  state
}
export default mesureTypeModule
